import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { useLanguage } from '../context/LanguageContext';

const MobileContactBar = () => {
  const { t, lang } = useLanguage();

  const trackContact = (actionName) => {
    if (window.fbq) {
      window.fbq('track', 'Contact', {
        language: lang,
        action: actionName
      });
    }
  };

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 p-2 sm:p-3 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)] z-50">
      <div className="flex justify-between items-center gap-1 sm:gap-2 max-w-md mx-auto">
        <a 
          href="tel:+17865291915" 
          onClick={() => trackContact('Call')}
          className="flex-1 flex flex-col items-center justify-center py-2 text-slate-600 hover:text-brand transition-colors rounded-lg hover:bg-slate-50"
        >
          <SafeIcon name="Phone" className="w-5 h-5 mb-0.5 sm:mb-1" />
          <span className="text-[10px] sm:text-xs font-medium text-center leading-tight">{t.mobileBar.call}</span>
        </a>
        <a 
          href="sms:+17865291915" 
          onClick={() => trackContact('Text')}
          className="flex-1 flex flex-col items-center justify-center py-2 text-slate-600 hover:text-brand transition-colors rounded-lg hover:bg-slate-50"
        >
          <SafeIcon name="MessageSquare" className="w-5 h-5 mb-0.5 sm:mb-1" />
          <span className="text-[10px] sm:text-xs font-medium text-center leading-tight">{t.mobileBar.text}</span>
        </a>
        <a 
          href="https://www.google.com/maps/dir/?api=1&destination=7429%20NW%20182nd%20St%2C%20Hialeah%2C%20FL%2033015" 
          target="_blank" 
          rel="noopener noreferrer" 
          aria-label={t.mobileBar.directionsAria}
          onClick={() => trackContact('Get Directions')}
          className="flex-1 flex flex-col items-center justify-center py-2 text-slate-600 hover:text-brand transition-colors rounded-lg hover:bg-slate-50"
        >
          <SafeIcon name="MapPin" className="w-5 h-5 mb-0.5 sm:mb-1" />
          <span className="text-[10px] sm:text-xs font-medium text-center leading-tight">{t.mobileBar.directions}</span>
        </a>
        <a 
          href="#contact" 
          onClick={() => trackContact('Request a Tour')}
          className="flex-[1.2] flex items-center justify-center py-2.5 px-2 bg-brand text-white rounded-xl shadow-sm font-medium text-sm hover:bg-brand-dark transition-colors text-center"
        >
          <SafeIcon name="Calendar" className="w-4 h-4 mr-1 sm:mr-1.5 flex-shrink-0" />
          {t.mobileBar.tour}
        </a>
      </div>
    </div>
  );
};

export default MobileContactBar;